var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"not-found-data"},[_c('div',{staticClass:"main"},[_c('img',{attrs:{"src":_vm.icon,"alt":"NOT-FOUND"}}),_c('p',{staticClass:"name"},[_vm._v(_vm._s(_vm.title))]),_c('p',{staticClass:"desc"},[_vm._v(_vm._s(_vm.desc))])])])}
var staticRenderFns = []

export { render, staticRenderFns }